export class VumProfileBrokenError extends Error {
    constructor(m?: string) {
        if (!m) {
            m = 'VUM profile seems to be broken';
        }
        super(m);
    }
}